import type { FC } from 'react';
import type { PickProps } from '@/ui/types/types';
import clsx from 'clsx';
import { motion } from 'framer-motion';
import styles from './Input.module.css';

type Props = {
    block?: boolean;
    error?: boolean;
} & PickProps<'input', 'type' | 'placeholder'
| 'value'
| 'onChange'
| 'onInput'
| 'onFocus'
| 'onBlur'
| 'name'
| 'disabled'
| 'min'
| 'max'>;

export const Input: FC<Props> = ({ block, error, type, disabled, ...props }) => (
    <motion.input
        initial={{ scale: 1 }}
        whileHover={{ scale: (!disabled ? 1.01 : 1) }}
        whileTap={{ scale: (!disabled ? 0.99 : 1) }}
        type={type || 'text'}
        disabled={disabled}
        aria-disabled={disabled}
        className={clsx(styles.input, block && styles.block, error && styles.error)}
        {...props}
    />
);
